export default {
    loadingIcon: {
        class: 'animate-spin',
    },
};
